import React from 'react';

import { FlyoutTrigger } from '@atlassian/entry-point-flyout';

import { objectListFlyoutEntrypoint } from './flyout-menu-item-content/entrypoint';
import type { ObjectListFlyoutProps } from './types';

/**
 * Component that renders a list of items in a flyout menu with searching & filtering capabilities in the list.
 * Consumers can provide the items data via the useItems hook.
 */
export function ObjectListFlyout(props: ObjectListFlyoutProps) {
	const {
		dropIndicator,
		elemBefore,
		hasDragIndicator,
		isDragging,
		label,
		labelElem,
		onClick,
		onOpenChange,
		testId,
		triggerRef,
		visualContentRef,
		isDefaultOpen,
	} = props;

	return (
		<FlyoutTrigger
			entryPoint={objectListFlyoutEntrypoint}
			entryPointProps={props}
			isDefaultOpen={isDefaultOpen}
			onOpenChange={onOpenChange}
			triggerProps={{
				elemBefore,
				children: labelElem ?? label,
				onClick,
				testId,
				hasDragIndicator,
				isDragging,
				dropIndicator,
				triggerRef,
				visualContentRef,
			}}
		/>
	);
}
